import { render } from "./LastConversation.vue?vue&type=template&id=b5d33f8a"
import script from "./LastConversation.vue?vue&type=script&lang=js"
export * from "./LastConversation.vue?vue&type=script&lang=js"

import "./LastConversation.vue?vue&type=style&index=0&id=b5d33f8a&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__